import React, {useEffect, useState} from 'react';
import Navbar from '../components/Navbar/Navbar';
import Checkout from '../components/Checkout/Checkout';
import Footer from '../components/Footer/Footer';
import {Navigate, useNavigate, useParams} from "react-router-dom";
import {canBeParsedToInt} from '../utils/GlobalUtils';
import {parseAndFormatDateFromSection} from '../utils/GlobalUtils';
import Listing from '../interfaces/Listing';
import {fetchEventById, fetchListingById} from '../api/endpoints';
import {isRight} from 'fp-ts/lib/Either';
import Event from '../interfaces/Event';
import ListingSource from '../interfaces/ListingSource';
import MobileLoading from "../components/MobileModals/MobileLoading";
import {useScreenSizeContext} from "../providers/ScreenSizeProvider";
import TagManager from "react-gtm-module";
import ReactGA from "react-ga4";


const CheckoutPage: React.FC = () => {

    const { selectedQuantity = '', isCustom = '', eventId = '', listingId = ''} = useParams<{ selectedQuantity: string, isCustom: string, eventId: string, listingId: string }>();
    const [event, setEvent] = useState<Event | null>(null)
    const [loadingEvent, setLoadingEvent] = useState<boolean>(true);

    const [listing, setListing] = useState<Listing | null>(null);
    const [loadingListing, setLoadingListing] = useState(true);
    const [isLoading, setIsLoading] = useState<boolean>(true); // Combined loading state, others still needed? MDK
    const [customEventDate, setCustomEventDate] = useState<string | null>(null);

    const navigate = useNavigate();
    const { isMobile } = useScreenSizeContext();

    useEffect(() => {
        // Google Analytics
        ReactGA.send({ hitType: 'pageview', page: "checkout-page"});


        const fetchEventAndListingData = async () => {
            setIsLoading(true);
            setLoadingEvent(true);
            setCustomEventDate(null);
            setLoadingListing(true);

            if (!canBeParsedToInt(eventId) || !canBeParsedToInt(listingId) || !canBeParsedToInt(selectedQuantity) || (isCustom !== "0" && isCustom !== "1")) {
                 navigate(`/not-found`);
                 return;
            }

            const parsedEventId = parseInt(eventId);
            const listingSource = isCustom === "0" ? ListingSource.TEVO : ListingSource.CUSTOM;

            try {
                const [eventDataEither, listingEither] = await Promise.all([
                    fetchEventById(parsedEventId, listingSource),
                    fetchListingById(listingId, parsedEventId, listingSource)
                ]);

                if (isRight(eventDataEither) && isRight(listingEither)) {
                    let fetchedEvent = eventDataEither.right;
                    const fetchedListing = listingEither.right;
                    let dateStringToSet: string | null = null;

                    if (isCustom === "1" && fetchedListing.section && !fetchedEvent.occursAtLocal) {
                        const extractedIsoDate = parseAndFormatDateFromSection(fetchedListing.section);
                        if (extractedIsoDate) {
                            fetchedEvent = {
                                ...fetchedEvent,
                                occursAtLocal: extractedIsoDate // override date
                            };
                            dateStringToSet = extractedIsoDate;
                        } else {
                             console.warn(`Failed to extract date from custom section: "${fetchedListing.section}". Using original event date.`);
                        }
                    }

                    setEvent(fetchedEvent);
                    setListing(fetchedListing);
                    setCustomEventDate(dateStringToSet);

                } else {
                    navigate(`/not-found`);
                }

            } catch (error) {
                navigate(`/not-found`);
            } finally {
                setIsLoading(false);
                setLoadingEvent(false);
                setLoadingListing(false);
            }
        };

        fetchEventAndListingData();

    // Add dependencies: whenever these change, refetch data
    }, [eventId, listingId, isCustom, selectedQuantity, navigate]);


    return (
        <div>
            {isMobile && <MobileLoading loading={isLoading} />}
            <Navbar showSearch={true} alwaysSolid={true}/>

            <Checkout event={event} loadingEvent={loadingEvent} listing={listing} loadingListing={loadingListing} selectedQuantity={parseInt(selectedQuantity)} customEventDate={customEventDate}/>
            
            <Footer/>
        </div>
    )
}

export default CheckoutPage;
